<script>
	import CommonHelper from "./CommonHelper";
	import store from "../../store.js";

	export default {
		getList: function(){
			var url = "/atlas/api/getAtlasList/"; // TODO: kažkur iškelti...
			var params = {
				owner: "", // FIXME: ar tokio parametro reikia?
				fragments: "" // FIXME: ar tokio parametro reikia?
			};
			if (store.state.userData) {
				// params.owner = store.state.userData.userName; // Nereikia to parametro? Jei jis bus, į rezultatus nebus įtraukti atlasai, kurie yra su manimi pasidalinti, bet aš nesu jų autorius???...
			}
			return this.getFetchPromise(url, params, "atlases");
		},
		getPublicList: function(){
			var url = "/atlas/api/getPublicAtlasList/"; // TODO: kažkur iškelti...
			return this.getFetchPromise(url, null, "atlases");
		},
		getPublicListByFilter: function(atlasType, owner){
			var url = "/atlas/api/getPublicAtlasList/";
			var params = {
				atlasType: atlasType,
				owner: owner
			};
			return this.getFetchPromise(url, params, "atlases");
		},
		getAtlasData: function(atlasId){
			var url = "/atlas/api/getAtlas/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId
			};
			var promise = new Promise(function(resolve, reject){
				this.getFetchPromise(url, params).then(function(response){
					if (!response["sources"]) {
						response["sources"] = "<a href='https://www.geoportal.lt'>geoportal.lt</a>";
					}
					if (!response["copyright"]) {
						response["copyright"] = "<a href='https://www.geoportal.lt/geoportal/autoriu-teises'>geoportal.lt autorių teisės</a>" ;
					}
					resolve(response);
				}, function(response){
					reject(response);
				});
			}.bind(this));
			return promise;
		},
		changeAtlasSharingType: function(atlasId, sharingType){
			var url = "/atlas/api/changeShareType/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				shareType: sharingType
			};
			return this.getFetchPromise(url, params);
		},
		deleteAtlas: function(atlasId){
			var url = "/atlas/api/deleteAtlas/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId
			};
			return this.getFetchPromise(url, params);
		},
		deleteAtlases: function(atlasesId){
			var url = "/atlas/api/deleteAtlas/"; // TODO: kažkur iškelti...
			var params = {
				AtlasesID: atlasesId
			};
			return this.getFetchPromise(url, params);
		},
		createNewPage: function(atlasId, pageContent){
			var url = "/atlas/api/createPage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				templateContent: pageContent
			};
			return this.getFetchPromise(url, params, "pageID");
		},
		createOrUpdateAtlas: function(atlasData, atlasId){
			var url;
			var params = Object.assign({}, atlasData);
			if (atlasId) {
				url = "/atlas/api/updateAtlas/"; // TODO: kažkur iškelti...
				params.atlasID = atlasId;
			} else {
				url = "/atlas/api/createAtlas/"; // TODO: kažkur iškelti...
			}
			return this.getFetchPromise(url, params);
		},
		getAtlasPagesList: function(atlasId){
			var url = "/atlas/api/getPageList/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId
			};
			return this.getFetchPromise(url, params, "pages");
		},
		updatePage: function(atlasId, pageId, pageContent){
			var url = "/atlas/api/updatePage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				pageID: pageId,
				templateContent: pageContent
			};
			return this.getFetchPromise(url, params);
		},
		updatePageOrder: function(atlasId, pageOrder){
			var url = "/atlas/api/updatePageOrder/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				pageOrder: pageOrder
			};
			return this.getFetchPromise(url, params);
		},
		deletePage: function(atlasId, pageId){
			var url = "/atlas/api/deletePage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				pageID: pageId
			};
			return this.getFetchPromise(url, params);
		},
		getPage: function(atlasId, pageId){
			var url = "/atlas/api/getPage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				pageID: pageId
			};
			return this.getFetchPromise(url, params);
		},
		shareAtlasWith: function(atlasId, userName, userRole, atlasTitle){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/api/addUser/"; // TODO: kažkur iškelti...
				var params = {
					atlasID: atlasId,
					username: userName,
					userRole: userRole
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success,
							rejectionReason;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									} else {
										if (json.message == "user not found.") {
											rejectionReason = "user-doesnt-exist";
										}
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							var msgContent = [
								atlasTitle,
								atlasId,
								userRole
							];
							CommonHelper.sendEmail(2, msgContent, userName);
							resolve();
						} else {
							reject(rejectionReason);
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		unshareAtlasWith: function(atlasId){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/api/unsubscribe/"; // TODO: kažkur iškelti...
				var params = {
					atlasID: atlasId
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		removeUserFromUsersList: function(atlasId, user, atlasTitle){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/api/removeUser/"; // TODO: kažkur iškelti...
				var params = {
					atlasID: atlasId,
					username: user.username
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							var msgContent = [
								atlasTitle,
								atlasId,
								user.userRole
							];
							CommonHelper.sendEmail(3, msgContent, user.username);
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		updateUser: function(atlasId, userName, userRole, atlasTitle){
			var promise = new Promise(function(resolve, reject){
				var url = "/atlas/api/updateUser/"; // TODO: kažkur iškelti...
				var params = {
					atlasID: atlasId,
					username: userName,
					userRole: userRole
				};
				setTimeout(function(){
					window.fetch(url, {
						method: "POST",
						body: JSON.stringify(params),
						headers: {
							"Content-Type": "application/json"
						}
					}).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var success;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										success = true;
									}
								}
							} catch(err) {
								// ...
							}
						}
						if (success) {
							var msgContent = [
								atlasTitle,
								atlasId,
								userRole
							];
							CommonHelper.sendEmail(2, msgContent, userName);
							resolve();
						} else {
							reject();
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			});
			return promise;
		},
		getAtlasUsersList: function(atlasId){
			var url = "/atlas/api/getAtlasUsersList/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId
			};
			return this.getFetchPromise(url, params, "users");
		},
		createImage: function(atlasId, image){
			var url = "/atlas/api/createImage/"; // TODO: kažkur iškelti...
			var formData = new FormData();
			formData.append("atlasID", atlasId);
			formData.append("file", image);
			return this.getFetchPromise(url, formData, null, true);
		},
		deleteAtlasImage: function(atlasId, atlasImageId){
			var url = "/atlas/api/deleteAtlasImage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				atlasImageID: atlasImageId
			};
			return this.getFetchPromise(url, params);
		},
		getImageUrl: function(atlasId, atlasImageId){
			var url = "/atlas/api/getImage/"; // TODO: kažkur iškelti...
			var params = {
				atlasID: atlasId,
				atlasImageID: atlasImageId
			};
			url += "?" + new URLSearchParams(params).toString();
			return url;
		},
		getFetchPromise: function(url, params, jsonParam, formData, method){
			var promise = new Promise(function(resolve, reject){
				var urlEnding = url;
				if (!params) {
					params = {};
				}
				var body,
					headers;
				if (formData) {
					body = params;
				} else {
					body = JSON.stringify(params);
					headers = {
						"Content-Type": "application/json"
					};
				}
				setTimeout(function(){
					var requestObject = {
						method: method || "POST"
					};
					if (requestObject.method == "POST") {
						requestObject.body = body;
						requestObject.headers = headers;
					}
					window.fetch(url, requestObject).then(function(response){
						if (response.status == 200) {
							return response.text();
						} else {
							reject();
						}
					}).then(function(text){
						var result, rejectReason;
						if (text) {
							try {
								var json = JSON.parse(text);
								if (json) {
									if (json.success) {
										if (jsonParam) {
											result = json[jsonParam];
										} else {
											result = json;
											if (urlEnding == "/atlas/api/getPage/") {
												if (result["templateContent"]) {
													result["templateContent"] = JSON.parse(result["templateContent"]);
												}
												result["pageId"] = params.pageID;
											}
										}
									} else {
										rejectReason = json;
									}
								}
							} catch(err) {
								console.warn(err);
							}
						}
						if (result) {
							resolve(result);
						} else {
							reject(rejectReason);
						}
					}.bind(this), function(){
						reject();
					});
				}.bind(this), store.state.testDelay);
			}.bind(this));
			return promise;
		},
		getPrintedAtlasUrl: function(atlasID){
			var url = "/atlas/api/getPrintedAtlas?atlasID=" + atlasID;
			return url;
		},
		getSharingTypeItems: function(){
			var sharingTypeItems = [{
				key: "private",
				name: "Privatus (nesidalijama)"
			},{
				key: "public",
				name: "Viešas"
			},{
				key: "privateShare",
				name: "Pasidalinta su"
			}];
			return sharingTypeItems;
		},
		getAtlasTypes: function(){
			var atlasTypes = [{
				key: "interactive",
				name: "Interaktyvus atlasas"
			},{
				key: "printable",
				name: "Atlasas, skirtas spausdinimui"
			}];
			return atlasTypes;
		},
		deleteAtlasConfirmation: function(positiveCallback, vBus, atlasData){
			var message;
			if (atlasData["atlasType"] == "interactive" && (atlasData["shareType"] == "privateShare" || atlasData["shareType"] == "public")) {
				message = "Jūs dalinatės atlasu su kitais vartotojais. Ar tikrai norite jį pašalinti?";
			}
			var e = {
				title: "Ar tikrai šalinti atlasą?",
				message: message || "Ar tikrai šalinti atlasą? Pašalinus atlasą jo atstatyti nebeįmanoma!",
				positiveActionTitle: "Šalinti atlasą",
				negativeActionTitle: "Atšaukti",
				positive: positiveCallback,
				positiveWarning: true
			};
			vBus.$emit("confirm", e);
		},
		deleteAtlasesConfirmation: function(positiveCallback, vBus, atlasesData){
			var message;
			atlasesData.forEach(function(atlasData){
				if (atlasData["atlasType"] == "interactive" && (atlasData["shareType"] == "privateShare" || atlasData["shareType"] == "public")) {
					message = "Bent vienas iš pažymėtų atlasų yra pasidalintas su kitais naudotojais. Ar tikrai norite juos pašalinti?";
				}
			});
			var e = {
				title: "Ar tikrai šalinti atlasus?",
				message: message || "Ar tikrai šalinti atlasus? Pašalinus atlasus jų atstatyti nebeįmanoma!",
				positiveActionTitle: "Šalinti atlasus",
				negativeActionTitle: "Atšaukti",
				positive: positiveCallback,
				positiveWarning: true
			};
			vBus.$emit("confirm", e);
		}
	}
	// BĖDOS:
	// getAtlasList() -> createDate() grąžinamas kaip string'as?
	// Reikia refactor'inti užklausos vykdymą. Beveik visur labai panašus kodas. Visur gi paduodi JSON, gauni JSON...
</script>